<div class="action-container" [hidden]="hidden">
  <i class="icon ic-eye-16" (click)="onOpen()"></i>
</div>
